import React from "react";
import { Mail, FileDown } from "lucide-react";
import { useLang, translateFr as tfr } from "@/i18n";
import { negCard } from "./negotiationShared";
import { cn } from "@/lib/utils";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const STATUS_FR = { sent: tfr("Envoyé"), failed: tfr("Échec"), sending: "Envoi…" };
const STATUS_TONE = {
  sent: "text-emerald-500 border-emerald-500/30 bg-emerald-500/5",
  failed: "text-red-500 border-red-500/40 bg-red-500/10",
  sending: "text-amber-500 border-amber-500/40 bg-amber-500/10",
};

export function NegotiationDeliveries({ neg, deliveries }) {
  const { tf, locale } = useLang();
  if (!deliveries || deliveries.length === 0) return null;
  return (
    <div className={cn(negCard, "p-4")} data-testid="neg-deliveries">
      <h3 className="text-[11px] uppercase tracking-[0.16em] font-semibold text-foreground/85 mb-3 flex items-center gap-2">
        <Mail className="h-3.5 w-3.5 text-red-500" /> {tf("Envois")}
      </h3>
      <div className="space-y-2">
        {deliveries.map((d) => (
          <div key={d.id} className="flex items-center gap-2 flex-wrap text-xs" data-testid={`neg-delivery-${d.id}`}>
            <span className={cn("px-1.5 py-0.5 rounded-md border text-[10px] font-semibold", STATUS_TONE[d.status] || "")}
              data-testid={`neg-delivery-status-${d.id}`}>
              {tf(STATUS_FR[d.status] || d.status)}
            </span>
            <span className="font-medium">V{d.version_number}</span>
            <span className="text-muted-foreground truncate max-w-[180px]">{d.recipient_email}</span>
            <span className="text-muted-foreground">{new Date(d.sent_at || d.created_at).toLocaleString(locale, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
            {d.sender && <span className="text-muted-foreground hidden sm:inline">· {d.sender}</span>}
            <span className="flex-1" />
            {d.document_id && (
              <a href={`${API_BASE}/api/contracts/${d.contract_id}/documents/${d.document_id}/download`}
                target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-red-500"
                title={tf("Télécharger")} data-testid={`neg-delivery-doc-${d.id}`}>
                <FileDown className="h-3.5 w-3.5" />
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
